import { Draft } from '@/types';
import { getIsConfigurationOnView } from '../configuration/getIsConfigurationOnView';
import { getViewId } from '../printArea/getViewId';
import { getDefaultViewId } from '../productType/getDefaultViewId';
import { getView } from '../productType/getView';
import { getConfigurations } from './getConfigurations';
import { getProductType } from './getProductType';

// to prevent preview images of blank product types in save, share, or basket:

export const getViewForPreview = (draft: Draft) => {
  const configurations = getConfigurations(draft);
  // check if current view has a configuration
  const configOnCurrentView = configurations.filter((configuration) =>
    getIsConfigurationOnView(configuration, draft.view)
  );
  // if no config on any image, show current view
  if (configOnCurrentView.length > 0 || configurations.length === 0) return draft.view;

  const productType = getProductType(draft);
  const defaultViewId = getDefaultViewId(productType);
  const defaultView = getView(productType, defaultViewId)!;
  // check if default view has a configuration, if so: use it
  const configOnDefaultView = configurations.filter((configuration) =>
    getIsConfigurationOnView(configuration, defaultView)
  );
  if (configOnDefaultView.length > 0) return defaultView;

  return getView(getProductType(draft), getViewId(configurations[0].printArea))!;
};
